<template>
  <v-app>
    <common-header ref="myHead"></common-header>
    <v-card v-if="isUpdate"
      color="orange" dark flat tile
    >
      <v-row style="padding:20px;">
        <div style="padding-top:2px;">アップデートが存在します。</div>
        <v-spacer></v-spacer>
        <v-btn small color=white class="orange--text" @click="onUpdate">更新する</v-btn>
      </v-row>
    </v-card>
    <v-container style="width:100%;max-width:800px;margin:0 auto;">
      <router-view
        @onMessage="onMessage"
      ></router-view>
    </v-container>
    <notifications
      group="mainMessage"
      position="center center"
      :speed="300" />
  </v-app>
</template>

<script>
import CommonHeader from './components/common/CommonHeader';

export default {
  name: 'App',

  components: {
    CommonHeader
  },

  data: () => ({
    //
  }),
  computed: {
    isUpdate () {
      return this.$store.state.user.isUpdate
    }
  },
  methods: {
    onMessage (message) {
      let group = 'mainMessage'
      let type = 'success'
      let title = 'Information'
      if (message.group) group = message.group
      if (message.type) type = message.type
      if (message.title) title = message.title

      this.$notify({
        group: group,
        type: type,
        title: title,
        text: message.text
      });
    },
    onUpdate () {
      location.reload()
    }
  }
};
</script>
<style>
  ul {
    padding: 0 ! important;
    margin: 0;
  }
  li {
    list-style: none;
  }
</style>
